<div mat-dialog-title>
  <h2>
    {{"manageSurveys.basicSurveyInformation"| translate}}
  </h2>
  <button mat-icon-button class="close" aria-label="Close" [disabled]="loading" (click)="openConfirmDialog()">
    <mat-icon class="pop-close">close</mat-icon>
  </button>
</div>
<form [formGroup]="formGroup">
  <mat-dialog-content class="pb-0">
    <div class="mat-dialog-body">
      <div class="form-group">
        <mat-form-field>
          <mat-label>{{"surveyTasks.respondentName" | translate}}</mat-label>
          <input matInput formControlName="respondentsName" minlength="3" maxlength="150">
          <mat-error *ngIf="hasError('respondentsName', 'required')">
            {{ 'surveyTasks.respondentNameRequired' | translate
            }}</mat-error>
          <mat-error *ngIf="hasError('respondentsName', 'maxlength')">
            {{"forms.maxLengthIsCharacters"|translate:{num:150} }}
          </mat-error>
          <mat-error *ngIf="hasError('respondentsName', 'minlength')">
            {{ 'forms.minLengthIsCharacters' | translate : {num:3} }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-group">
        <mat-form-field>
          <mat-label>{{"surveyTasks.age" | translate}}</mat-label>
          <input matInput formControlName="respondentsAge" appOnlynumber minlength="1" maxlength="3">
          <mat-error *ngIf="hasError('respondentsAge', 'required')">
            {{ 'surveyTasks.ageRequired' | translate
            }}</mat-error>
          <mat-error *ngIf="hasError('respondentsAge', 'maxlength')">
            {{"forms.maxLengthIsCharacters"|translate:{num:3} }}
          </mat-error>
          <mat-error *ngIf="hasError('respondentsAge', 'minlength')">
            {{ 'forms.minLengthIsCharacters' | translate : {num:1} }}
          </mat-error>
          <mat-hint>{{data.details.targetAudience.ageRangeFrom}} - {{data.details.targetAudience.ageRangeTo}}</mat-hint>
        </mat-form-field>
      </div>
      <div class="mat-dialog-inner">
        <h3 class="subtitle-form">{{"surveyTasks.selectRegion" | translate}}</h3>
        <div class="form-group">
          <mat-form-field>
            <mat-label>{{ 'surveyTasks.selectRegion' | translate }}</mat-label>
            <mat-select formControlName="surveyRequestSuveryGeographicScopeId">
              <mat-option *ngFor="let item of geographicScopes" [value]="item.id">
                {{item.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="hasError('surveyRequestSuveryGeographicScopeId', 'required')">
              {{ 'surveyTasks.regionRequired' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="mat-dialog-inner">
        <h3 class="subtitle-form">{{"manageSurveys.gender" | translate}}</h3>
        <div class="form-group">
          <div class="radio-selector">
            <mat-radio-group formControlName="targetAudienceGender" class="flex-grow-1">
              <div class="row">
                <mat-radio-button class="col-6 m-0 mb-2" [value]="targetAudienceGenderEnum.Male">{{"fields.male" |
                  translate}}</mat-radio-button>
                <mat-radio-button class="col-6 m-0 mb-2" [value]="targetAudienceGenderEnum.Female">{{"fields.female" |
                  translate}}</mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button type="button" class="btn-grey" [disabled]="loading" (click)="openConfirmDialog()">
      {{"forms.Cancel" | translate}}
    </button>
    <button (click)="saveRecord()" mat-raised-button color="primary" [disabled]="loading" [class.loading]="loading">
      {{ "evaluationTasks.startSurvey" | translate}}
    </button>
  </mat-dialog-actions>
</form>
